import { LocalStorage } from "quasar"

export function TABLES_LOADING (state, status) {
  state['loading'] = status
}

export function TABLES_SET_SELECTED (state, table) {
  state['selected'] = table
}

export function TABLES_SET_ORDERS_TABLE (state, table) {
  state['table'] = table
}

export function TABLES_SET (state, tables) {
  state['all'] = tables
}

export function TABLES_SET_PIN (state, payload) {
  state.pin = payload
  LocalStorage.set('tables.pin', payload)
}
export function TABLES_SET_PRESET_TABLE_ID (state, payload) {
  state.presetTableId = payload
  LocalStorage.set('tables.preset', payload)
}
